/** Only for full-page or button loading — never over a photo (UI_GUIDELINES §5 Spinner). */
export function Spinner({ className = '' }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Nalaganje"
      className={`inline-block h-5 w-5 animate-spin rounded-full border-2 border-line-strong border-t-fg ${className}`}
    />
  );
}

export function PageSpinner() {
  return (
    <div className="flex h-full min-h-[240px] w-full items-center justify-center">
      <Spinner className="h-8 w-8" />
    </div>
  );
}
